import Wrapper from "../../layout/wrapper/Wrapper";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import styles from "../../styles/pages/submit.module.scss";
import styles1 from "../../styles/pages/submithome.module.scss";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
// import NoResult from "../../components/NoResult/NoResult";
import Filter from "../../components/Filter/Filter";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import SubmitHeader from "../../components/SubmitHeader/SubmitHeader";
import { useQuery } from "react-query";
import { FetchSubmitedVideos } from "../../api/functions/submited.videos.api";
import { useState } from "react";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
  setUserId,
  setAgreementWithAnotherCompany,
  setHasMessage,
  setFrom,
  setHasNote,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setTo,
  setUnreachableSubmitter,
  setMonth,
  setYear,
  setSubmitPlace,
  setApiActiveTwo,
} from "../../redux-toolkit/slices/submitted.rejected.slice ";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import NoResultTwo from "../../components/NoResult/NoResultTwo";
import ApiLoader from "../../components/Loaders/ApiLoader";
import SubmittedRejectedTable from "../../components/AllTable/SubmittedPageVideos/SubmittedRejectedTable";
import SubmittedRejectedTableTwo from "../../components/AllTable/SubmittedPageVideos/SubmittedRejectedTableTwo";
import { getStartEndDateTwo } from "../../lib/functions/utils.lib";

function Rejected() {
  const [page, setPage] = useState(1);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const dispatch = useAppDispatch();

  const [fetchTrigger, setFetchTrigger] = useState(Date.now());

  const {
    user_id,
    month,
    year,
    hasMessage,
    has_note,
    unreachable_submitter,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
    submit_place,
    confirmed,
    apiActiveTwo,
  } = useAppSelector((s) => s.submittedRejectedSlice);

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(["rejected1"], async () =>
    FetchSubmitedVideos({
      status: 2,
      page,
      has_note,
      unreachable_submitter,
      people_appearing,
      from: month || year ? getStartEndDateTwo(month, year).start_date : from,
      to: month || year ? getStartEndDateTwo(month, year).end_date : to,
      hasMessage,
      person_who_filmed,
      aggrement_with_another_company,
      user_id,
      submit_place: submit_other_website,
      country: submit_place,
    })
  );
  const {
    error: error2,
    data: data2,
    isLoading: isLoading2,
    isRefetching: isRefetching2,
    refetch: refetchAgain2,
  } = useQuery(
    ["rejected2"],
    async () =>
      FetchSubmitedVideos({
        // status: 1,
        manager_decision: 2,
        awaiting_confirmation: "yes",
        page,
        has_note,
        unreachable_submitter,
        people_appearing,
        from,
        to,
        hasMessage,
        person_who_filmed,
        aggrement_with_another_company,
        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
        user_id,
        submit_place: submit_other_website,
        country: submit_place,
      }),
    {
      enabled: apiActiveTwo && data ? true : false,
      onSuccess: (d2) => {
        // console.warn("d2", d2?.data?.data);
        if (d2?.data?.data?.length < 1) {
          setApiActiveTwo(false);
        }
      },
    }
  );

  // console.warn('data', data)
  // console.warn('isLoading', isLoading)

  // const handlePageChange = (p) => {
  //   setPage(p);
  // };
  const handlePageChange = (p) => {
    setPage(p);
    handleTriggreFetch();
  };

  const filterRefetch = () => {
    // console.warn("refetch", confirmed);
    if (confirmed) {
      refetchAgain();
    } else {
      refetchAgain2();
    }
    setOpenFilterModal(false);
  };

  useEffect(() => {
    if (confirmed) {
      refetchAgain();
    } else {
      refetchAgain2();
    }
  }, [fetchTrigger]);

  // const filterRefetch = () => {
  //   refetchAgain();
  //   setOpenFilterModal(false);
  // };
  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };
  const filtersReset = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setHasMessage(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    setPage(1);
    handleTriggreFetch();
  };

  const [filterActive, setFilterActive] = useState(false);

  // console.warn("filterActive", filterActive);

  useEffect(() => {
    if (
      user_id ||
      month ||
      year ||
      hasMessage ||
      has_note ||
      unreachable_submitter ||
      people_appearing ||
      person_who_filmed ||
      submit_other_website ||
      aggrement_with_another_company ||
      submit_place
    ) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [
    user_id,
    month,
    year,
    hasMessage,
    has_note,
    unreachable_submitter,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    submit_place,
  ]);

  return (
    <Wrapper>
      <ApiLoader loading={isLoading || isLoading2} />

      <Box className="main_body">
        <SubmitHeader />

        <Box className={styles.submitPageWrapper}>
          <Box className={styles1.submitTable}>
            <SubmittedRejectedTableTwo
              datas={confirmed ? data?.data : data2?.data}
              handlePageChange={handlePageChange}
              filterRefetch={filterRefetch}
              handleClearFilterModal={filtersReset}
              setPage={setPage}
              page={page}
              confirmed={confirmed}
              filtersReset={filtersReset}
              filterActive={filterActive}
              handleTriggreFetch={handleTriggreFetch}
              loading={isLoading}
              p={{
                openFilterModal,
                setOpenFilterModal,
                handleTriggreFetch,
                filtersReset,
                data2,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Wrapper>
  );
}

export default Rejected;
